module.exports = __webpack_public_path__ + "img/IMG_5915.e1ce0620.jpg";